import React, {useCallback, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Popover} from 'antd';
import {useStores} from '@src/components/store';
import {DeactivateVersionButton} from '@src/components/shared/deactivate-version/deactivate-version';
import MoreIcon from '@svg/more.svg?react';
import AllowIcon from '@svg/allow-circle.svg?react';
import BlockIcon from '@svg/restricted_icon_black.svg?react';

import './bronze-categories-more-menu.scss';

/** Three-dots menu for Bronze Categories: Block All, Allow All, and Deactivate/Reactivate DNS Protection. */
export const BronzeCategoriesMoreMenu: React.FC = observer(() => {
    const {fwVersionBronzeStore} = useStores();

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const closePopover = useCallback(() => setIsPopoverOpen(false), []);

    const handleBlockAll = useCallback(() => {
        closePopover();
        fwVersionBronzeStore.blockAllCategories();
    }, [fwVersionBronzeStore, closePopover]);

    const handleAllowAll = useCallback(() => {
        closePopover();
        fwVersionBronzeStore.allowAllCategories();
    }, [fwVersionBronzeStore, closePopover]);

    const isEditable = !fwVersionBronzeStore.isDnsProtectionDeactivated
        && fwVersionBronzeStore.isSelectedBronzeVersionEditable;

    return (
        <Popover
            placement="bottomRight"
            overlayClassName="popover-overlay-menu bronze-categories-more-popover"
            content={
                <div className="bronze-categories-more-menu">
                    <DeactivateVersionButton
                        protectionType="DNS_PROTECTION"
                        className="menu-item"
                        disabled={fwVersionBronzeStore.isPendingVersion}
                        closePanel={closePopover}/>
                    <button type="button" className="menu-item" disabled={!isEditable} onClick={handleBlockAll}>
                        <BlockIcon/><span>Block All Categories</span>
                    </button>
                    <button type="button" className="menu-item" disabled={!isEditable} onClick={handleAllowAll}>
                        <AllowIcon/><span>Allow All Categories</span>
                    </button>
                </div>
            }
            open={isPopoverOpen}
            trigger="click"
            showArrow={false}
            onOpenChange={() => setIsPopoverOpen(!isPopoverOpen)}
        >
            <div className="bronze-categories-more-icon-wrapper">
                <MoreIcon/>
            </div>
        </Popover>
    );
});


